// extracted by mini-css-extract-plugin
module.exports = {"price":"Qk-z","onSale":"Rk-z"};